'use strict';

const onLocationsListViewTypeChanged = (auth, siteName) => {
	return {
		id: 'ViewTypeChange',
		f: () => {
			auth.forceReloadUser(siteName);
		}
	};
};

module.exports = {
	onLocationsListViewTypeChanged
};
